<template>
    <div class="sidebar">
        <div class="sidebar-header">
            <h3>Formulario</h3>
        </div>
        <div class="sidebar-content">
            <div class="sidebar-section">
                <h4>Campos</h4>
                <div class="field-list">
                    <div v-for="field in fields" 
                         :key="field.id" 
                         class="field-item"
                         :class="{ 'active': field.isDragOver || field.isSelected }"
                         @click="selectField($event, field)">
                         <div class="field-data">
                          <span class="field-name">{{ field.name }}</span>
                          <span class="field-type">{{ field.idGroup && field.idGroup.length > 20 ? field.idGroup.substring(0, 20) + '...' : field.idGroup }}</span>  
                        </div>
                        <div class="field-delete" @click="deleteField(field)">
                            <i class="pi pi-trash"></i>
                        </div>
                    </div>
                  
                </div>
            </div>
            <div class="sidebar-section" v-if="fields.filter(field => field.isSelected).length > 1">
                <h4>Grupos</h4>

                <div class="p-field-radiobutton">
                    <RadioButton id="option1" name="option" value="Checkbox" v-model="typeGroup" />
                    <label for="option1">Checkbox</label>
                  </div>
                  <div class="p-field-radiobutton">
                    <RadioButton id="option2" name="option" value="Radio" v-model="typeGroup" />
                    <label for="option2">Radio</label>
                  </div>
                  <div class="p-field-radiobutton">
                    <RadioButton id="option3" name="option" value="List" v-model="typeGroup" />
                    <label for="option3">List</label>                    
                    <InputText v-if="typeGroup === 'List'" v-model="labelGroup" placeholder="Label" style="width: 100%;" />
                  </div>

                  <button class="p-button p-button-primary" @click="handleCreateGroup">Crear Grupo</button>
            </div>

            <div class="sidebar-section">
                <h4>Elementos</h4>
                <div class="elements-list">
                    <div class="element-item" 
                         draggable="true"
                         @dragstart="handleElementDragStart($event, 'Label')"
                         @dragend="handleDragEnd($event)"
                         data-element-type="Label">
                        <div class="element-icon">
                            <i class="pi pi-tag"></i>
                        </div>
                        <div class="element-info">
                            <span class="element-name">Label</span>
                            <span class="element-description">Texto de etiqueta</span>
                        </div>
                    </div>
                    <div class="element-item" 
                         draggable="true"
                         @dragstart="handleElementDragStart($event, 'Image')"
                         @dragend="handleDragEnd($event)"
                         data-element-type="Image">
                        <div class="element-icon">
                            <i class="pi pi-image"></i>
                        </div>
                        <div class="element-info">
                            <span class="element-name">Image</span>
                            <span class="element-description">Imagenn</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="sidebar-section">
                <h4>Configuración</h4>
                <div class="config-options">
                    <div class="config-item">
                        <label class="config-label">
                            <span>Debug</span>
                            <InputSwitch 
                                :modelValue="debugMode"
                                @change="toggleDebugMode"
                                class="debug-switch" />
                        </label>
                    </div>
                </div>
            </div>

            <div class="sidebar-section">
                <h4>Estilos</h4>
                <div class="styles-options">
                      <Textarea :value="defaultStyles" placeholder="Estilos" class="styles-textarea" @change="handleOnChangeStyles($event)"/>
                </div>
            </div>

            <div class="sidebar-section">
                <h4>Estadísticas</h4>
                <div class="stats">
                    <div class="stat-item">
                        <span class="stat-label">Total campos:</span>
                        <span class="stat-value">{{ fields.length }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">Filas:</span>
                        <span class="stat-value">{{ getUniqueRows().length }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">Tipos:</span>
                        <span class="stat-value">{{ getUniqueFieldTypes().length }}</span>
                    </div>
                </div>
            </div>
            
            <div class="sidebar-section">
                <h4>Acciones</h4>
                <div class="action-buttons">
                    <button @click="exportForm" class="action-btn export-btn">
                        <i class="pi pi-download"></i>
                        Exportar
                    </button>
                    <button @click="importForm" class="action-btn import-btn">
                        <i class="pi pi-upload"></i>
                        Importar
                    </button>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { InputSwitch } from 'primevue/inputswitch';
import { v4 as uuidv4 } from 'uuid';

export default {
    name: 'FormSidebar',
    components: {
        InputSwitch
    },
    data()  {
      return {
        styles: '',
        typeGroup: 'Checkbox',
        labelGroup: ''
      }
    },
    mounted() {
          this.styles = this.defaultStyles;
          this.$emit('change-styles', this.styles);
    },
    props: {
        fields: {
            type: Array,
            required: true
        },
        debugMode: {  
            type: Boolean,
            required: false,
            default: false
        },
        data: {
            type: Object,
            required: true
        },
        defaultStyles: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'select-field',
        'toggle-debug',
        'export-form',
        'import-form',
        'clear-form',
        'element-drag-start',
        'drag-end'
    ],
    methods: {
       
        // Toggle del modo debug
        toggleDebugMode() {   
            console.log('toggleDebugMode', !this.debugMode);
            this.$emit('toggle-debug');
        },
        
        // Sidebar methods
        getUniqueRows() {
            const rows = [...new Set(this.fields.map(f => f.row))].sort((a, b) => a - b);
            return rows;
        },
        
        getUniqueFieldTypes() {
            const types = [...new Set(this.fields.map(f => f.type))];
            return types;
        },
        
        exportForm() {
            this.$emit('export-form');
        },
        
        importForm() {
            this.$emit('import-form');
        },
        
        selectField(event, field) {
                   
          this.$emit('select-field', { event, field });
        },
        handleCreateGroup() {
           const idGroup = this.uuidLettersOnly();
           
            this.fields.map(field => {
                if (field.isSelected) {
                    field.idGroup = idGroup;
                    field.typeGroup = this.typeGroup;
                    field.labelGroup = this.labelGroup;
                }
            });

            this.$emit('group-fields', idGroup);
        },        
        handleElementDragStart(event, elementType) {
          event.dataTransfer.setData('text/plain', JSON.stringify({
                type: 'newElement',
                elementType,
                id: uuidv4()
            }));
          
          event.dataTransfer.effectAllowed = 'move';
            
          // Efecto visual
          event.target.style.opacity = '0.5';          
        },
        
        handleDragEnd(event) {
            //this.$emit('drag-end', event);
            if (event.target) {
                event.target.style.opacity = '';
            }
        },
        uuidLettersOnly() {
          const chars = 'abcdefghijklmnopqrstuvwxyz';
          let result = '';
          for (let i = 0; i < 32; i++) { // 32 para que se parezca al uuid sin guiones
            result += chars.charAt(Math.floor(Math.random() * chars.length));
          }
          return result;
        },
        deleteField(field) {
          this.$emit('delete-field', field);
        },

        handleOnChangeStyles(event) {
          this.$emit('change-styles', event.target.value);
        }
    }
}
</script>

<style scoped>
/* Barra lateral */
.sidebar {
  width: 300px;
  background-color: #f8f9fa;
  border-right: 1px solid #dee2e6;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
  background-color: #ffffff;
}

.sidebar-header h3 {
  margin: 0;
  color: #495057;
  font-size: 1.5rem;
}

.sidebar-content {
  flex: 1;
  padding: 20px;
}

.sidebar-section {
  margin-bottom: 30px;
}

.sidebar-section h4 {
  margin: 0 0 15px 0;
  color: #495057;
  font-size: 1.1rem;
  font-weight: 600;
}

/* Estilos para el panel de configuración */
.config-options {
  margin-top: 10px;
}

.config-item {
  margin-bottom: 15px;
}

.config-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
}

.styles-options {
  margin-top: 10px;
}

.styles-textarea {
  width: 100%;
  height: 300px;
}

.debug-switch {
  margin-left: 10px;
}

/* Lista de campos */
.field-list {
  max-height: 300px;
  overflow-y: auto;
}

.field-item {
  padding: 10px;
  margin-bottom: 8px;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.field-item:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.field-item.active {
  background-color: #007bff;
  color: white;
  border-color: #0056b3;
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
}

.field-name {
  display: block;
  font-weight: 600;
  margin-bottom: 4px;
}

.field-data {
  flex: 1;
}

.field-delete {
  cursor: pointer;
  color: #dc3545;
}

.field-type {
  display: block;
  font-size: 0.85rem;
  color: #6c757d;
  margin-bottom: 2px;
}

.field-item.active .field-type {
  color: #b3d7ff;
}

.field-position {
  display: block;
  font-size: 0.8rem;
  color: #adb5bd;
}

.field-item.active .field-position {
  color: #b3d7ff;
}

/* Estadísticas */
.stats {
  background-color: #ffffff;
  border-radius: 6px;
  padding: 15px;
  border: 1px solid #dee2e6;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f3f4;
}

.stat-item:last-child {
  border-bottom: none;
}

.stat-label {
  font-weight: 500;
  color: #495057;
}

.stat-value {
  font-weight: 600;
  color: #007bff;
  background-color: #e7f3ff;
  padding: 2px 8px;
  border-radius: 4px;
}

/* Botones de acción */
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  color: white;
}

.action-btn i {
  font-size: 14px;
}

.export-btn {
  background-color: #28a745;
}

.export-btn:hover {
  background-color: #218838;
}

.import-btn {
  background-color: #17a2b8;
}

.import-btn:hover {
  background-color: #138496;
}

.clear-btn {
  background-color: #dc3545;
}

.clear-btn:hover {
  background-color: #c82333;
}

/* Elementos arrastrables */
.elements-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.element-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background-color: #ffffff;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: grab;
  transition: all 0.3s ease;
  user-select: none;
}

.element-item:hover {
  border-color: #007bff;
  background-color: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
}

.element-item:active {
  cursor: grabbing;
  transform: translateY(0);
}

.element-icon {
  width: 32px;
  height: 32px;
  background-color: #007bff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 14px;
}

.element-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.element-name {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
}

.element-description {
  font-size: 0.75rem;
  color: #6c757d;
}
</style> 